module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0106.jpg?v=1b48cd9e";